module.exports = __webpack_public_path__ + "img/choosebackup.fe487a79.svg";